import styled from 'styled-components';
import { LoadImage, Title } from 'components';
import { px2rem } from 'src/util';
import Text from 'components/Text';

const blockHeight = 1083;

export const Wrapper = styled.section`
  position: relative;
  width: 100%;

  @media screen and (min-width: 998px) {
    background-image: linear-gradient(
      120.5deg,
      #4b5966 5.16%,
      #4b5966 5.17%,
      #2e3740 69.41%
    );
    padding-bottom: ${(blockHeight / 1920) * 100}%;
  }

  @media screen and (max-width: 997px) {
    align-items: center;
    background: linear-gradient(96.48deg, #4b5966 5.16%, #2e3740 69.41%);
    display: flex;
    flex-direction: column;
    padding: 51px 20px 93px;
  }
`;

export const BackgroundImage = styled(LoadImage)`
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
`;

export const IntegrationImage = styled(LoadImage)`
  @media screen and (min-width: 998px) {
    left: 50%;
    position: absolute;
    top: ${(208 / blockHeight) * 100}%;
    transform: translateX(-50%);
    width: ${(1145 / 1920) * 100}%;
  }

  @media screen and (max-width: 997px) {
    height: 767px;
    max-width: 100%;
  }
`;

export const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  text-align: center;

  ${Title}, ${Text} {
    color: #fff;
  }

  @media screen and (min-width: 1201px) {
    padding-top: ${(111 / 1920) * 100}%;
  }

  @media screen and (max-width: 1200px) and (min-width: 998px) {
    padding-top: ${(80 / 1920) * 100}%;
  }

  @media screen and (min-width: 998px) {
    left: 50%;
    position: absolute;
    top: 0;
    transform: translateX(-50%);
    z-index: 1;

    ${Title} {
      margin-bottom: ${px2rem(24)};
    }

    ${Text} {
      max-width: ${px2rem(420)};
    }
  }

  @media screen and (max-width: 997px) {
    margin-bottom: 50px;

    ${Title} {
      font-size: 32px;
      margin-bottom: 16px;
    }

    ${Text} {
      max-width: 271px;
    }
  }
`;
